<div class="content">
  <div class="content-header">
    <div class="title-primary">{{'PatientDetailsPrimaryTitle' | cpLoginTranslate | async}}</div>
    <div class="title-secondary">{{'PatientDetailsSecondaryTitle' | cpLoginTranslate | async}}</div>
    <app-information-box class="information-box"
                [text1]="informationText1"
                [text2]="informationText2"
                [text3]="informationText3"
                [actionTextIndex]="informationActionTextIndex"
                [icon]="'pp-icon-info'"
                (onAction)="informationAction()">
    </app-information-box>
  </div>
  <app-web-form-container class="web-form"
                          *ngIf="showForm"
                          [URL]="patientDetailsURL"
                          #PatientDetailsForm
                          (dataValidated)="dataValidated($event)"
                          (dataReceived)="dataReceived($event)">
  </app-web-form-container>
  <div class="buttons-wrapper">
    <cp-button-widget-custom class="primary-button call-to-action" captionToTranslate="Continue.Login.PP" [disabled]="!patientDataValidated" (onClick)="continue()"></cp-button-widget-custom>
  </div>
</div>
